"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArticleToProductUpdateConversion = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ArticleToProductUpdateConversion = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ArticleToProductUpdateConversion, _Component);

  var _super = _createSuper(ArticleToProductUpdateConversion);

  function ArticleToProductUpdateConversion(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ArticleToProductUpdateConversion);
    _this = _super.call(this, props);
    _this.state = {
      isModalOpen: false,
      isLoading: false,
      showError: false
    };
    _this.handleConversion = _this.handleConversion.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleModalClose = _this.handleModalClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleArticleToProductUpdateConversion = _this.handleArticleToProductUpdateConversion.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ArticleToProductUpdateConversion, [{
    key: "handleArticleToProductUpdateConversion",
    value: function () {
      var _handleArticleToProductUpdateConversion = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.setState({
                  isLoading: true,
                  showError: false
                });
                _context.next = 4;
                return _axios.default.post("/community/api/articles/".concat(this.props.articleId, "/convertToProductUpdate"));

              case 4:
                this.setState({
                  isLoading: false
                });
                this.handleModalClose();
                window.location.assign('/product-update/overview?conversion=true');
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                this.setState({
                  isLoading: false,
                  showError: true
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function handleArticleToProductUpdateConversion() {
        return _handleArticleToProductUpdateConversion.apply(this, arguments);
      }

      return handleArticleToProductUpdateConversion;
    }()
  }, {
    key: "handleModalClose",
    value: function handleModalClose() {
      this.setState({
        isModalOpen: false,
        showError: false
      });
    }
  }, {
    key: "handleConversion",
    value: function handleConversion(e) {
      e.stopPropagation();
      e.preventDefault();
      this.setState({
        isModalOpen: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isModalOpen = _this$state.isModalOpen,
          isLoading = _this$state.isLoading,
          showError = _this$state.showError;
      return (0, _preact.h)("div", {
        className: "article-to-product-updates",
        onMouseDown: function onMouseDown(e) {
          return _this2.handleConversion(e);
        }
      }, (0, _preact.h)("span", null, "Convert to product update"), isModalOpen ? (0, _preact.h)(_Modal.Modal, {
        isOpen: isModalOpen
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Convert article to product update",
        onClose: this.handleModalClose
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("p", null, "Are you sure that you want to convert this article to a product update?"), (0, _preact.h)("p", null, "Please note that some article properties will be lost during this conversion, e.g. attachments, content helpfulness data, etc."), (0, _preact.h)("p", null, (0, _preact.h)("strong", null, "This action can\u2019t be reverted.")), showError ? (0, _preact.h)("div", {
        className: "error-message-container"
      }, (0, _preact.h)(_assets.default, {
        width: 20,
        height: 20,
        customClass: "icon-warning",
        icon: "warning"
      }), (0, _preact.h)("div", {
        className: "error-message"
      }, "Sorry, we were unable to convert this topic, please check your internet connection and try it again.")) : null), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        isLoading: isLoading,
        title: "Convert",
        newStyle: true,
        variant: "brand",
        size: "medium",
        onClick: this.handleArticleToProductUpdateConversion
      }), (0, _preact.h)(_buttonControl.default, {
        title: "Cancel",
        size: "medium",
        newStyle: true,
        onClick: this.handleModalClose
      }))) : null);
    }
  }]);
  return ArticleToProductUpdateConversion;
}(_preact.Component);

exports.ArticleToProductUpdateConversion = ArticleToProductUpdateConversion;
var _default = ArticleToProductUpdateConversion;
exports.default = _default;